import { useCallback } from 'react';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import { useGetBoundaryGroup } from '~/store/boundaryGroups/boundaryGroups.selectors';

export const useBoundaryGroupCheckRemainingGeometryCalls = () => {
  const { getBoundaryGroupById } = useGetBoundaryGroup();

  const checkBoundaryGroupRemainingGeometryCalls = useCallback((boundaryGroupId: BoundaryGroupId) => {
    const boundaryGroup = getBoundaryGroupById(boundaryGroupId);
    if (!boundaryGroup) {
      return null;
    }

    return boundaryGroup.wms.geometryRemainingCalls ?? boundaryGroup.mot.geometryRemainingCalls ?? null;
  }, [getBoundaryGroupById]);

  return {
    checkBoundaryGroupRemainingGeometryCalls,
  };
};
